<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ForecastDateIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
